import { getReviews, deleteReview, respondToReview } from "../../../api/api";
import {CrudTable} from "../crud_tables/crud_tables";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

export const ReviewsSection = () => {
    const [reviews, setReviews] = useState<any[]>([]);
    const [selected, setSelected] = useState<any>(null);
    const [response, setResponse] = useState('');
    const {t} = useTranslation()

    const load = () => getReviews().then((data: any[]) => setReviews(data)).catch(console.error);
    useEffect(() => { load(); }, []);

    const handleDelete = async (id: number) => {
        if (!window.confirm('Supprimer cet avis ?')) return;
        await deleteReview(id);
        setSelected(null);
        load();
    };

    const handleSelect = (row: any) => {
        setSelected(selected?.id === row.id ? null : row);
        setResponse(row.response || '');
    };

    const handleRespond = async () => {
        if (!selected || !response.trim()) return;
        const updated = await respondToReview(selected.id, response);
        setSelected(updated);
        load();
    };

    return (
        <div>
            <div className="admin-card">
                <CrudTable
                    cols={['id', 'customerName', 'title', 'createdAt']}
                    rows={reviews}
                    onEdit={handleSelect}
                    onDelete={handleDelete}
                />
            </div>

            {selected && (
                <div className="admin-card">
                    <div>
                        <p>
                            {t("admin.reviews.review")} #{selected.id} — {selected.customerName}
                        </p>
                        <button className="btn-admin btn-admin-danger" onClick={() => handleDelete(selected.id)}>
                            Supprimer
                        </button>
                    </div>
                    <p>{selected.title}</p>
                    <p>{selected.content}</p>
                    <p>
                        Posté le {new Date(selected.createdAt).toLocaleDateString('fr-FR')}
                    </p>
                    {selected.response && (
                        <div>
                            <p>
                                {t("admin.reviews.mariposa-reply")} - {new Date(selected.respondedAt).toLocaleDateString('fr-FR')}
                            </p>
                            <p>{selected.response}</p>
                        </div>
                    )}
                    <div className="admin-field">
                        <label>{selected.response ? 'Modifier la réponse' : 'Répondre'}</label>
                        <textarea
                            rows={4}
                            value={response}
                            onChange={e => setResponse(e.target.value)}
                            placeholder="Votre réponse..."
                        />
                    </div>
                    <button className="btn-admin btn-admin-primary" onClick={handleRespond}>
                        {selected.response ? 'Mettre à jour' : 'Envoyer la réponse'}
                    </button>
                </div>
            )}
        </div>
    );
};
